import { render, staticRenderFns } from "./academy.vue?vue&type=template&id=6c80ed2e"
import script from "./academy.vue?vue&type=script&lang=ts"
export * from "./academy.vue?vue&type=script&lang=ts"
import style0 from "./academy.vue?vue&type=style&index=0&id=6c80ed2e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports